<template>
  <article class="message" :class="accordionClasses">
    <div class="message-header is-uppercase" @click="toggleAccordion">{{this.header}}</div>
    <div class="message-body">
      <div class="message-content">
        <slot></slot>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: "AccordionComponent",
  props: ["active", "header"],
  data() {
    return {
      isOpen: this.active
    };
  },
  computed: {
    accordionClasses: function() {
      return {
        "is-closed": !this.isOpen,
        "is-active": this.isOpen
      };
    }
  },
  methods: {
    toggleAccordion: function() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/colors.scss";

.message {
  // max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.message-header {
  cursor: pointer;
}

.message.is-closed .message-header {
  background: #072d3d;
}

.message.is-active .message-header {
  background: #072d3d;
}

.message-body {
  background: rgba(7, 45, 61, 0.05);
}

.message-body {
  padding: 0;
  max-height: 500vh;
  overflow: hidden;
  transition: 0.3s ease all;
}

.is-closed .message-body {
  max-height: 0;
}

.message-content {
  padding: 20px;
}
</style>
